const mutations = {
    ENROLL_LOADING: (state) => {
        state.enrollStatus = 'loading';
    },
    ENROLL_SUCCESS: (state, data) => {
        state.enrollStatus = 'success';
        Vue.set(state, 'enrollments', data);
    },
    ENROLL_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.enrollStatus = 'error';
        state.enrollErrors.record(errors);
    },
    CLEAR_ENROLL_ERRORS: (state) => {
        state.enrollStatus = '';
        state.enrollErrors.clear();
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
